export default __webpack_public_path__ + "static/media/uploadLink.ae50c349.svg";